import { render, staticRenderFns } from "./recomCoupons.vue?vue&type=template&id=d12fd2ba&scoped=true&"
import script from "./recomCoupons.vue?vue&type=script&lang=js&"
export * from "./recomCoupons.vue?vue&type=script&lang=js&"
import style0 from "./recomCoupons.vue?vue&type=style&index=0&id=d12fd2ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12fd2ba",
  null
  
)

export default component.exports